<template>
  <EkitabuCheckbox
    :id="id"
    :value="localValue"
    :label="label"
    v-bind="$attrs"
    :disabled="isUpdating"
    :loading="isUpdating"
    :error="hasError"
    :success="showSuccess"
    @input="onInput"
  />
</template>

<script>
import ProductInfoFieldMixin from '@/mixins/ProductInfoFieldMixin';
import EkitabuCheckbox from '@/components/EkitabuCheckbox.vue';

export default {
  name: 'LocalBookCheckbox',
  components: {
    EkitabuCheckbox
  },
  mixins: [ProductInfoFieldMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    }
  },
  emits: ['value'],
  watch: {
    localValue(newValue) {
      this.$emit('value', newValue);
    }
  }
};
</script>